/**
 * Created by pzf on 2018/12/26
 *
 */
import Layout from './LayoutList';
import Basic from '../_layout';
import generator from '../_layout/util';
import AutoHeight from './AutoHeight';



const Header = generator({
  prefixCls: 'mkui-layout-list-header',
})(Basic);
const Content = generator({
  prefixCls: 'mkui-layout-list-content',
})(Basic);
const ToolBar = generator({
  prefixCls: 'mkui-layout-list-content-toolbar',
})(Basic);
const Filter = generator({
  prefixCls: 'mkui-layout-list-content-filter',
})(Basic);
const Table = generator({
  prefixCls: 'mkui-layout-list-content-table',
})(Basic);
Content.ListToolBar = ToolBar;
Content.ListFilterWrapper = Filter;
Content.ListTableWrapper = Table;
Layout.ListHeader = Header;
Layout.ListContent = Content;
Layout.AutoHeight = AutoHeight;
export default Layout;
